import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { PROPERTIES } from '../constants';
import { FormType } from '../types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getNonDeletableFormReason = (crmForm, cosIndexObjects) => {
  const formName = getPropertyValue(crmForm, PROPERTIES.NAME);
  const formType = getPropertyValue(crmForm, PROPERTIES.FORM_TYPE);
  const deletable = getPropertyValue(crmForm, PROPERTIES.DELETABLE) === 'true';
  const isBlogComment = formType === FormType.BLOG_COMMENT;
  if (isBlogComment) return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "dashboard.frameworkTable.bulkActions.delete.nonDeletableReason.isBlogComment",
    options: {
      formName
    }
  });
  const hasUsages = Boolean(cosIndexObjects && cosIndexObjects.length);
  if (hasUsages) return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "dashboard.frameworkTable.bulkActions.delete.nonDeletableReason.hasUsages",
    options: {
      formName
    }
  });
  const noDeletableFlagAndNotRegularForm = !deletable && formType !== FormType.HUBSPOT;
  if (noDeletableFlagAndNotRegularForm) return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "dashboard.frameworkTable.bulkActions.delete.nonDeletableReason.other",
    options: {
      formName
    }
  });
  return null;
};
export const isDeletableForm = (crmForm, cosIndexObjectsMap) => {
  const formId = getPropertyValue(crmForm, PROPERTIES.FORM_ID);
  return getNonDeletableFormReason(crmForm, cosIndexObjectsMap[formId]) !== null;
};